import HttpRequest from "../http_request";

class DocumentApi extends HttpRequest {
  apiGetTaxInvoice(data) {
    return this.fetch(`/client/v1/tax-invoices`, data);
  }
  apiGetTaxInvoiceByid(id) {
    return this.fetch(`/client/v1/tax-invoices/${id}/document`);
  }
  apiGetTaxInvoiceByidDetail(id) {
    return this.fetch(`/client/v1/tax-invoices/${id}`);
  }
  apiGetTexInvoiceGetLink(id) {
    return this.fetch(`/client/v1/tax-invoices/${id}/e-tax`);
  }

  apiGetPrintTaxinvoice (id) {
    return this.fetch(`/client/v1/tax-invoices/${id}/e-tax`)
  }
}

export default DocumentApi;
